import React, { useEffect, useState } from 'react';
import { States } from '@/helpers/common/states';
import api, { AxiosError } from '@/services/api';
import { toast } from 'react-toastify';
import { EventProductMainReport } from '@/model/EventProductMainReport';
import { SaleProductProductsContent } from './ui';
import { ReportControllerProps } from '../../types';

interface StateProps {
  reportController: ReportControllerProps;
  setState: (state: States) => void;
  onExportPDF?: (mainData: EventProductMainReport) => void;
}

export const SaleProductProducts: React.FC<StateProps> = ({
  reportController,
  setState,
  onExportPDF,
}) => {
  const { eventId, singleEvent } = reportController;
  const [productName, setProductName] = useState('');
  const [userName, setUserName] = useState('');

  const [main, setMain] = useState<EventProductMainReport>({
    products: [],
    courtesies: [],
  });

  const handleGetSaleProducts = async (
    filterProduct = productName,
    filterUser = userName,
  ): Promise<void> => {
    try {
      setState(States.loading);

      const params = new URLSearchParams();
      params.append('singleEvent', String(singleEvent));
      if (filterProduct.trim()) {
        params.append('productName', filterProduct.trim());
      }
      if (filterUser.trim()) {
        params.append('userName', filterUser.trim());
      }

      const { data } = await api.get<EventProductMainReport>(
        `event/report/${eventId}/sale-product/product?${params.toString()}`,
      );
      if (data) {
        setMain(data);
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  const handleClearFilter = (): void => {
    setProductName('');
    setUserName('');
    handleGetSaleProducts('', '');
  };

  useEffect(() => {
    handleGetSaleProducts();
  }, [singleEvent]);

  return (
    <SaleProductProductsContent
      main={main}
      productName={productName}
      userName={userName}
      onChangeProductName={setProductName}
      onChangeUserName={setUserName}
      onFilter={() => handleGetSaleProducts()}
      onClearFilter={handleClearFilter}
      onExportPDF={onExportPDF ? () => onExportPDF(main) : undefined}
    />
  );
};
